import apiClient, { safeJson } from '@/api/client';
import {
    CenterNotice,
    CenterNoticeListParams,
    CenterNoticeListResponse,
    CreateCenterNoticeBody,
    UpdateCenterNoticeBody,
    PresignMediaContent,
    PresignMediaContentResponse,
} from './types';

/**
 * @method post
 * @brief 공지 이미지 Presigned URL 발급
 */
export const getNoticePresignedUrls = async ({
    centerId,
    mediaContents,
}: {
    centerId: string;
    mediaContents: PresignMediaContent[];
}) => {
    const res = await apiClient.post(`v1/centerNotices/presign/${centerId}`, {
        json: { mediaContents },
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as PresignMediaContentResponse[] | null,
    };
};

/**
 * @method get
 * @brief 공지 목록 조회
 */
export const getCenterNoticeList = async ({ centerId, page, limit }: CenterNoticeListParams) => {
    const searchParams: Record<string, string> = {};
    if (page !== undefined) searchParams.page = String(page);
    if (limit !== undefined) searchParams.limit = String(limit);

    const res = await apiClient.get(`v1/centerNotices/${centerId}`, { searchParams });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CenterNoticeListResponse | null,
    };
};

/**
 * @method post
 * @brief 공지 작성
 */
export const createCenterNotice = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: CreateCenterNoticeBody;
}) => {
    const res = await apiClient.post(`v1/centerNotices/${centerId}`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CenterNotice | null,
    };
};

/**
 * @method patch
 * @brief 공지 수정
 */
export const updateCenterNotice = async ({
    centerId,
    noticeId,
    body,
}: {
    centerId: string;
    noticeId: string;
    body: UpdateCenterNoticeBody;
}) => {
    const res = await apiClient.patch(`v1/centerNotices/${centerId}/notice/${noticeId}`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CenterNotice | null,
    };
};

/**
 * @method delete
 * @brief 공지 삭제(취소)
 */
export const deleteCenterNotice = async ({
    centerId,
    noticeId,
}: {
    centerId: string;
    noticeId: string;
}) => {
    const res = await apiClient.delete(`v1/centerNotices/${centerId}/notice/${noticeId}`);

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as { success: boolean } | null,
    };
};
